/**
 * Investment comparables row (France)
 */
export class FranceInvestmentComparablesRow {
  /**
   * The OID
   */
  oid: number;

  /**
   * The reference
   */
  ref: string;

  /**
   * The date
   */
  date: Date;

  /**
    * The size
    */ 
  size: number;

  /**
   * The address
   */
  address: string;

  /**
   * The price
   */
  price: number;

  /**
   * The price per area
   */
  pricePerArea: number;

  /**
   * The NIY
   */
  reportValuationNetInitialYield: number;

  /**
   * The WALT
   */
  tenantWalt: number;

  /**
   * The WABO
   */
  WABO: number;

  /**
   * The comment
   */
  comment: string;
}
